function validateNumberMaxTwoDecimals(int) {
  //check if its valid integer or decimal number (max 2 digits after ".")
  var re = /^[0-9]*\.?[0-9]?[0-9]?$/g;
  return re.test(int);
}
export default validateNumberMaxTwoDecimals;
